import { compose, withStateHandlers, lifecycle } from 'recompose'

// We need this to understand that we're on client and not on server side.
// See issue description and solution here https://github.com/facebook/react/issues/10591
const withClientState = withStateHandlers(
  { hasMounted: false },
  { setHasMounted: () => () => ({ hasMounted: true }) }
)

const withClientInitialization = lifecycle({
  componentDidMount() {
    this.props.setHasMounted()
  }
})

export default compose(
  withClientState,
  withClientInitialization
)
